// Season-event scaffolding: a hall may declare an opening window, and outside
// it the hall simply doesn't exist — not on the map, not at its route. Kept
// apart from the registry so the date logic stays importable by unit tests
// without dragging in React and the lazy hall chunks.

export type HallWindow = {
  /** ISO timestamp (UTC recommended, e.g. "2026-12-31T00:00:00Z"). Inclusive. */
  from: string;
  /** ISO timestamp. Inclusive. Date-only strings parse as UTC midnight — the
   *  window ends as that day *begins*, so spell the last day out in full. */
  to: string;
};

export function isWindowOpen(w: HallWindow | undefined, now: Date): boolean {
  if (!w) return true;
  const from = Date.parse(w.from);
  const to = Date.parse(w.to);
  // A window that doesn't parse must fail closed: a typo in an event date
  // should never quietly turn a seasonal hall into a permanent one.
  if (Number.isNaN(from) || Number.isNaN(to)) return false;
  const t = now.getTime();
  return t >= from && t <= to;
}
